export const Routes = {
    Default: {
        path: "/"
    },
    Login: {
        path: "/login"
    },
    Dashboard: {
        path: "/dashboard"
    },
    Survey: {
        path: "/survey-category/survey/:id"
    },
     Home: {
        path: "/home"
    },
     ProductView: {
        path: "/home/product-details/:id"
    },
     StageMapping: {
        path: "/stage-mapping"
    },
    CreateSurvey: {
        path: "/survey-category/survey/create-survey"
    },
    SurveyCategory: {
        path: "/survey-category"
    },
    EditSurvey: {
        path: "/survey-category/survey/edit-survey"
    },
    SureveyDetails: {
        path: "/survey-category/survey/survey-details/:id"
    },
    User: {
        path: "/users"
    },
    UserDetails: {
        path: "/users/user-details/:id"
    },
    SurveyView: {
        path: "/users/user-survey/:id/:leadId"
    },
    OdoUserDetails: {
        path: "/users/odouser-details/:id"
    },
    SubmittedAnwers: {
        path: "/users/submitted-answers/:id"
    },
    Setting: {
        path: "/settings"
    },
    Faq: {
        path: "/faq-categories/faq/:id"
    },
    FaqCategories: {
        path: "/faq-categories"
    },
    ForgotPassword: {
        path: "/forgot-password"
    },   
    CreatePassword: {
        path: "/create-password"
    },
    ResetPassword: {
        path: "/reset-password"
    },
    UserTarcking: {
        path: "/user-tracking"
    },
    TrackingUserDetails: {
        path: "/user-tracking/details/:id"
    },
}